import React, { useState } from 'react';

import PositionFilter from '../../Shared/Filters/PositionFilter';
import { YearSeasonFilter } from '../../Shared/Filters/YearSeasonFilter/YearSeasonFilter';
import RadioPracticesGames from './RadioPracticesGames';
import { FILTER_KEYS, GAMES, PRACTICES, SEASON_FILTER } from '../../../config/constants';
import SimpleMultiSelector from '../../Shared/Filters/SimpleMultiSelector';
import { buildIntensityFilter, routeToSpecificScope } from '../../../helpers';
import { useRouter } from '../../../helpers/customHooks';
import { TeamRoutes } from '../types';
import { selectIntensitiesByTeam, useFiltersState } from 'store/hooks';
import { useSelector } from 'react-redux';
type Props = {
  teamId?: string
}

export default ({teamId}: Props) => {
  
  const { location, match } = useRouter<TeamRoutes>();
  const [showFilter, setShowFilter] = useState(-1);
  const { specificScope } = useRouter();
  const {[FILTER_KEYS.DATE_RANGE]: year} = useFiltersState(specificScope, FILTER_KEYS.TEAM_ID, FILTER_KEYS.DATE_RANGE);
  const defaultYear = year?.year;
  const close = () => setShowFilter(-1);
  const currentDate = new Date();
  const filterSeasonData = new URLSearchParams(location.search).get(SEASON_FILTER.filterKey) || '';
  const params = location.pathname.split('/');
  if (params[5] === PRACTICES) {
    params[5] = GAMES;
  } else {
    params[5] = PRACTICES;
  }
  const intensities = useSelector(
  selectIntensitiesByTeam(teamId!!)
);
  const intensityFilter = buildIntensityFilter(intensities?? []);
  return (
    <div className="head-filters-01">
      <YearSeasonFilter
        show={showFilter === 4}
        close={close}
        open={() => setShowFilter(4)}
        // [january, august]  should display a past year, [september, december] should shown a current year
        defaultYear={ !isNaN(+filterSeasonData) ? +filterSeasonData : ((match.params.event === GAMES && currentDate.getMonth() <= 7) ? currentDate.getFullYear() - 1 : currentDate.getFullYear())}
        onlySeasonWeeks={match.params.event === GAMES}
        urlPersistent
      />
      {match.params.tab === 'playerPerformance' && (
        <PositionFilter
          show={showFilter === 1}
          close={close}
          open={() => setShowFilter(1)}
          otherScopes={[routeToSpecificScope(params.join('/'))]}
        />
      )}
      {match.params.tab === 'teamPerformance' && match.params.event === PRACTICES && (
        <SimpleMultiSelector
          type={intensityFilter}
          show={showFilter === 1}
          close={close}
          open={() => setShowFilter(1)}
        />
      )}
      <RadioPracticesGames />
    </div>
  );
};
